import axios from "axios";
import { domain } from "../../../Links/Links";

export async function salesHistoryRequest(setRequestStatus, setData) {
    setRequestStatus(true);

    const response = await axios.get(domain + '/sales_history/' , {
        withCredentials: true,
    })

    console.log(response.data);

    if (response.data) {
        setData(response.data);
        setRequestStatus(false);
    }
}